import _classCallCheck from "/codebuild/output/src223969145/src/jackrobinsonmedia/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _assertThisInitialized from "/codebuild/output/src223969145/src/jackrobinsonmedia/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/codebuild/output/src223969145/src/jackrobinsonmedia/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/codebuild/output/src223969145/src/jackrobinsonmedia/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf2 from "/codebuild/output/src223969145/src/jackrobinsonmedia/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf2(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf2(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import _decorate from "@babel/runtime/helpers/esm/decorate";
import _get from "@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
/**
 * @license
 *
 * Copyright IBM Corp. 2020, 2021
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { customElement } from 'lit-element';
import ddsSettings from '@carbon/ibmdotcom-utilities/es/utilities/settings/settings';
import styles from "./button-group.css.js";
import DDSButtonExpressive from "../button/button.js";
var ddsPrefix = ddsSettings.stablePrefix;
/**
 * Button group item.
 *
 * @element dds-button-group-item
 */

var DDSButtonGroupItem = _decorate([customElement("".concat(ddsPrefix, "-button-group-item"))], function (_initialize, _DDSButtonExpressive) {
  var DDSButtonGroupItem = /*#__PURE__*/function (_DDSButtonExpressive2) {
    _inherits(DDSButtonGroupItem, _DDSButtonExpressive2);

    var _super = _createSuper(DDSButtonGroupItem);

    function DDSButtonGroupItem() {
      var _this;

      _classCallCheck(this, DDSButtonGroupItem);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _super.call.apply(_super, [this].concat(args));

      _initialize(_assertThisInitialized(_this));

      return _this;
    }

    return DDSButtonGroupItem;
  }(_DDSButtonExpressive);

  return {
    F: DDSButtonGroupItem,
    d: [{
      kind: "get",
      static: true,
      key: "stableSelector",
      value: function stableSelector() {
        return "".concat(ddsPrefix, "--button-group-item");
      }
    }, {
      kind: "method",
      key: "connectedCallback",
      value: function connectedCallback() {
        _get(_getPrototypeOf(DDSButtonGroupItem.prototype), "connectedCallback", this).call(this);

        if (!this.hasAttribute('role')) {
          this.setAttribute('role', 'listitem');
        }
      }
    }, {
      kind: "field",
      static: true,
      key: "styles",
      value: function value() {
        return styles;
      }
    }]
  };
}, DDSButtonExpressive);

export default DDSButtonGroupItem;